var neutral = {
  0: '#ffffff',
  40: '#f8f8f8',
  50: '#f1f1f2',
  200: '#d6d6da',
  400: '#afb2ba',
  600: '#555768',
  700: '#383838',
  800: '#202020',
  900: '#000000'
};
export default neutral;